import { Component, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { FieldCoreComponent } from "../FieldCoreComponent";

@Component({
  selector: "med-checkbox",
  templateUrl: "./med-checkbox.component.html",
  styleUrls: ["./med-checkbox.component.scss"],
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MedCheckboxComponent),
  }],
})
export class MedCheckboxComponent extends FieldCoreComponent<boolean> {
  @Input() tabindex = 0;
}
